import { SUITE } from "../../common/apiUrl/suite/suiteUrls";
import { API } from "../../common/model/objectTypes";
import { officeLocationInfo } from "../../utils/apiDescription/suite/officeLocation";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader } from "../../utils/objectTypeConstants";
import { getAllLocationResponseBody, getAllLocationsRequestParameter, locationByIdRequestParameter, locationByIdResponseBody } from "../../utils/suite/apiObjects";
import { getAllLocationsRequestCurl, locationByIdRequestCurl } from "../../utils/suite/sampleJsonRequest";
import { commonOfficeLocationJsonResponse } from "../../utils/suite/sampleJsonResponse";

const AllLocation: API = {
    name: "All Locations",
    url: `${API_BASE_URL}/${SUITE.OFFICE_LOCATION.Get_ALL_LOCATION_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: officeLocationInfo.allLocation,
    requestBody: getAllLocationsRequestParameter,
    responseBody: getAllLocationResponseBody,
    jsonRequest: getAllLocationsRequestCurl,
    jsonResponse: commonOfficeLocationJsonResponse,
}

const LocationById: API = {
    name: "Location By Id",
    url: `${API_BASE_URL}/${SUITE.OFFICE_LOCATION.LOCATION_BY_ID_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: officeLocationInfo.locationById,
    requestBody: locationByIdRequestParameter,
    responseBody: locationByIdResponseBody,
    jsonRequest: locationByIdRequestCurl,
    jsonResponse: commonOfficeLocationJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return AllLocation;
        case 'Location By Id':
            return LocationById;
    }
}